import { createFileRoute, redirect } from '@tanstack/react-router'

import { storeAuth } from '@/lib/auth'
import { LoadingScreen } from '@/components/shared/loading-logo'
// import { successLogin } from '@/lib/api'

export const Route = createFileRoute('/_auth/login-success')({
  component: LoadingScreen,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      code: (search.code as string) || '',
    }
  },
  beforeLoad: async ({ search, context }) => {
    const { code } = search
    const { getAccessTokenSilently, user, isAuthenticated, logout } =
      context.auth

    const token = await getAccessTokenSilently()
    storeAuth(token)

    try {
      console.info('Success login', user?.email, code)
      // await successLogin(token, user?.email, code)
    } catch (e) {
      console.info('Success login error')
      console.error('Error /login-success', e)
      logout()

      return
    }

    const returnTo = sessionStorage.getItem('returnTo')
    sessionStorage.removeItem('returnTo')
    sessionStorage.removeItem('returnToCs')

    console.info('Redirecting', isAuthenticated, returnTo)

    if (isAuthenticated) {
      throw redirect({ to: returnTo || '/accounts' })
    }
  },
})
